import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Agencia.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

export default function Agencias() {

  const location = useLocation();
  const [tipoActivo, setTipoActivo] = useState("Agente Aduanal");
  const [agencias, setAgencias] = useState([]);
  const navigate = useNavigate();

  const tipos = [
    { id: "Agente Aduanal", label: "Aduanales", icon: "fas fa-anchor" },
    { id: "aseguradora", label: "Aseguradoras", icon: "fas fa-shield-alt" },
    { id: "Corredor público", label: "Corredores públicos", icon: "fas fa-gavel" },
    { id: "Agente Naviero", label: "Agentes Navieros", icon: "fas fa-dharmachakra"}
  ];

    useEffect(() => {
    if (location.state && location.state.tipo) {
      setTipoActivo(location.state.tipo);
    }
  }, [location]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/agencia/tipo/${tipoActivo}`)
      .then((res) => res.json())
      .then((data) => setAgencias(data))
      .catch(() => setAgencias([]));
  }, [tipoActivo]);

  const irADetalle = (id) => {
    navigate(`/agencia/${id}`);
  };

  return (
    <div className="Filtro agencias">
      <div className="tabs-container">
        {tipos.map((tipo) => (
          <div
            key={tipo.id}
            className={`tab ${tipoActivo === tipo.id ? "active" : ""}`}
            onClick={() => setTipoActivo(tipo.id)}
          >
            <i className={tipo.icon}></i>
            <span>{tipo.label}</span>
          </div>
        ))}
      </div>

      <div className="contenedor-agencias">
        <h2>Agencias {tipoActivo}</h2>
        {tipoActivo === "Agente Aduanal" && (
          <p>Una agencia aduanal tiene como objetivo apoyar a las empresas e individuos en el despacho aduanero y cumplimiento de regulaciones.</p>
        )}
        {tipoActivo === "aseguradora" && (
          <p>Una aseguradora proporciona cobertura ante riesgos mediante contratos de seguros para bienes y personas.</p>
        )}
        {tipoActivo === "Corredor público" && (
          <p>Un corredor público actúa como fedatario y asesor legal en actos mercantiles, facilitando transacciones comerciales.</p>
        )}

        <div className="lista-agencias">
          {agencias.length === 0 ? (
            <p>No hay agencias registradas en esta categoría.</p>
          ) : (
            agencias.map((agencia) => (
              <div
                key={agencia.id}
                className="tarjeta-agencia"
                onClick={() => irADetalle(agencia.id)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={agencia.urlImagen || "/assets/logo_placeholder.png"}
                  alt={`Logo de ${agencia.nombre}`}
                  referrerPolicy="no-referrer"
                />

                <h4>{agencia.nombre}</h4>
                <p>{agencia.estado}, {agencia.municipio}</p>
                <p>Puntuación:</p>
                <div className="estrellas">⭐⭐⭐⭐⭐</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}